// Designations list page (CHG-1251 / ITER-3374).
//
// Thin per the v11 brief: page files ≤30 LOC, all configuration in
// @generated/screens. Future generator regenerates designationListConfig
// from designation.entity-hint.yaml (CHG-1237) without touching this file.
//
// Spec: specs/tier-05-experience/designations-v2.cross-screen.yaml.

import { ListPage } from "../components/composition";
import { designationListConfig } from "../generated/screens/designation-list";

export function Designations() {
  return <ListPage config={designationListConfig} />;
}
